import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { FlashDeals } from "@/components/FlashDeals";
import { ZonesExplorer } from "@/components/ZonesExplorer";
import { GuestFavorites } from "@/components/GuestFavorites";
import { GuestVoices } from "@/components/GuestVoices";
import { MapSection } from "@/components/MapSection";
import { Manifesto } from "@/components/Manifesto";
import { Footer } from "@/components/Footer";
import { Seo } from "@/lib/seo";
import { useApp } from "@/context/AppContext";

export default function Home() {
  const { t } = useApp();
  return (
    <div className="overflow-x-hidden">
      <Seo
        title={t("detail.seo_home_title")}
        description={t("detail.seo_home_desc")}
        url={`${window.location.origin}/`}
        image="https://umagobestprice.com/logo512.png"
      />
      <Navbar />
      <Hero />
      <Marquee />
      <FlashDeals />
      <ZonesExplorer />
      <GuestFavorites />
      <GuestVoices />
      <MapSection />
      <Manifesto />
      <Footer />
    </div>
  );
}
